import { Stack, Text } from "@reverb-ui/react";
import React from "react";
var InfoItem = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement(Stack, { flex: 1, direction: "column", spacing: 0.5 },
        React.createElement(Text, { color: "gray.500", fontSize: "sm", fontWeight: "normal", marginBottom: "6px" }, label),
        React.createElement(Text, { wordBreak: "break-word", whiteSpace: "pre-line", color: "black", fontSize: "md", fontWeight: "normal" }, value)));
};
export default InfoItem;
